class AppPaths {
  static readonly main = [
    { name: "Home", path: "/" },
    { name: "About", path: "/about" },
    { name: "Work", path: "/work" },
    // { name: "Blog", path: "/blog" },
    { name: "Contact", path: "/contact" },
  ];
}

export default AppPaths;
